// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-detail-modal-content {
    width: 60rem !important;
    min-height: 37rem !important;
}`, "",{"version":3,"sources":["webpack://./src/Pages/ValidatorDelegator/UserDetailModal.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,4BAA4B;AAChC","sourcesContent":[".user-detail-modal-content {\n    width: 60rem !important;\n    min-height: 37rem !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
